import React from 'react';
import { BOTTOM_INDENTS, COLORS, validateDebounce, VALIDATION_RULES } from '@constants';
import { CONTACT_VALUE_TYPE, NOTIFICATION_ACTIONS } from '@enums';
import { useStore } from '@hooks';
import { Input, Typography, WhiteCover } from '@ui';
import { Checkbox, Col, Form, Row } from 'antd';
import { observer } from 'mobx-react';
import { FIELD_NAMES } from '../../constants';
import DeleteBtn from '..//DeleteBtn';

const { VALUE_TYPE, VALUE, NOTIFY_ON_ACTIONS, NOTIFICATION_CONTACTS } = FIELD_NAMES;

const NotificationContact = observer(({ contact, remove }) => {
    const store = useStore();
    const { klicklyEmail } = store.accountsStore;

    const form = Form.useFormInstance();

    const valueType = form.getFieldValue([NOTIFICATION_CONTACTS, contact.name, VALUE_TYPE]) || CONTACT_VALUE_TYPE.EMAIL;
    const contactItem = form.getFieldValue([NOTIFICATION_CONTACTS, contact.name]);

    const isKlicklyEmail = contactItem.id === klicklyEmail.id;

    const input =
        valueType === CONTACT_VALUE_TYPE.EMAIL ? (
            <Input disabled={isKlicklyEmail} label='Contact Email' />
        ) : (
            <Input.Phone />
        );
    const rules =
        valueType === CONTACT_VALUE_TYPE.EMAIL
            ? [...VALIDATION_RULES.REQUIRED, ...VALIDATION_RULES.EMAIL]
            : [...VALIDATION_RULES.REQUIRED, ...VALIDATION_RULES.PHONE];

    return (
        <WhiteCover data-e2e='notifications_contact-method_form' hasDivider={false}>
            {!isKlicklyEmail && (
                <DeleteBtn
                    onClick={() => {
                        remove(contact.name);
                    }}
                />
            )}

            <Row gutter={16} style={BOTTOM_INDENTS.S}>
                <Col span={0}>
                    <Form.Item name={[contact.name, VALUE_TYPE]} initialValue={CONTACT_VALUE_TYPE.EMAIL} hidden>
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        data-e2e='notifications_contact-method_input'
                        rules={rules}
                        name={[contact.name, VALUE]}
                        validateDebounce={validateDebounce}
                        normalize={(value) => value?.trim()}
                    >
                        {input}
                    </Form.Item>
                </Col>
            </Row>
            <Typography.Text type='body2' color={COLORS.$gray60Black} style={BOTTOM_INDENTS.S}>
                Select the types of notifications to receive
            </Typography.Text>
            <Form.Item name={[contact.name, NOTIFY_ON_ACTIONS]}>
                <Checkbox.Group style={{ display: 'flex', width: '100%' }}>
                    <Row>
                        <Col span={6}>
                            <Checkbox
                                data-e2e='notifications_account_checkbox'
                                disabled={isKlicklyEmail}
                                label='account'
                                value={NOTIFICATION_ACTIONS.ACCOUNT}
                            >
                                Account
                            </Checkbox>
                        </Col>
                        <Col span={6}>
                            <Checkbox
                                data-e2e='notifications_marketing_checkbox'
                                label='marketing'
                                value={NOTIFICATION_ACTIONS.MARKETING}
                            >
                                Marketing
                            </Checkbox>
                        </Col>
                        <Col span={6}>
                            <Checkbox
                                data-e2e='notifications_campaign_checkbox'
                                label='campaign'
                                value={NOTIFICATION_ACTIONS.CAMPAIGN}
                            >
                                Campaign
                            </Checkbox>
                        </Col>
                    </Row>
                </Checkbox.Group>
            </Form.Item>
        </WhiteCover>
    );
});

export default NotificationContact;
